// extracted by mini-css-extract-plugin
module.exports = {"root":"FlowStatsView_root__IfFVg","filters":"FlowStatsView_filters__3rhpe","tabs":"FlowStatsView_tabs__IJcJ8","body":"FlowStatsView_body__238xF"};